import React from "react";

function DivisionArrowsSvg({ className }) {
    return (
        <svg className={className} width="22" height="10" viewBox="0 0 22 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5L1 9" stroke="#9FE870" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 1L13 5L9 9" stroke="#9FE870" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17 1L21 5L17 9" stroke="#9FE870" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default DivisionArrowsSvg;
